/*@flow*/
import * as t from 'lib/t';

export default t.irreducible(
  'BooleanString',
  (v) => v === 'false' || v === 'true'
);
